import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { getBindingDefinitions } from '../business-logic/bindings/componentBindingInfo'
import { getUserInputFilterConnection } from '../panels/connection-config-panel/utils'
import type { AppApi } from '@wix/wix-data-client-common'
import type { ComponentRef, Connection } from '@wix/editor-platform-sdk-types'

export const getUserFilterAndTotalCountConnections = async ({
  editorSdkProxy,
  appApi,
  sdkType,
  componentType,
  componentRef,
  connections,
}: {
  editorSdkProxy: EditorSDK
  appApi: AppApi
  sdkType: string
  componentType: string
  componentRef: ComponentRef
  connections: Connection[]
}) => {
  const bindingDefinitions = (
    await getBindingDefinitions({
      editorSdkProxy,
      appApi,
      componentType: sdkType,
      componentViewerType: componentType,
      componentRef,
    })
  ).getOrElse(null)

  const userInputFilterConnection = getUserInputFilterConnection({
    bindingDefinitions,
    connections,
  })

  const totalCountConnections = connections.filter(
    ({ config }) => config?.totalCount,
  )

  return totalCountConnections
    .concat(userInputFilterConnection ?? [])
    .map(({ controllerRef, role }) => ({
      componentRef,
      controllerRef,
      role,
    }))
}
